module.exports = __webpack_public_path__ + "bcf769169475270a3b7990d1a3d9606c.png";